import React from "react";
import { Modal } from "react-bootstrap";
import "./HomePage.css";
const CenteredMenuModal = ({
  show,
  handleClose,
  manualDetect,
  handleShowImageModal,
  handleShowDriveOff,
  handleShowIOU,
  handleShowManualInputModal,
  handleShowShopliftingModal
}) => {
  return (
    <Modal show={show} onHide={handleClose} centered>
      <div className="popup-box" id="centered-menu-box">
        <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={handleShowImageModal}
        >
          SHOW IMAGE
        </button>
        <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={handleShowDriveOff}
        >
          DRIVE OFF
        </button>
        <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={handleShowIOU}
        >
          IOU
        </button>
        <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={manualDetect}
        >
          MANUAL DETECT
        </button>
        <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={handleShowManualInputModal}
        >
          MANUAL INPUT
        </button>
        {/* <button
          type="button"
          className="btn btn-primary modal-button text-center"
          onClick={handleShowShopliftingModal}
        >
          SHOPLIFTING
        </button> */}
        <button
          className=" btn btn-primary modal-button option-close text-center"
          onClick={handleClose}
        >
          CLOSE
        </button>
      </div>
    </Modal>
  );
};

export default CenteredMenuModal;